import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { Process } from './components/Process';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { About } from './components/About';
import { Footer } from './components/Footer';
import { Impressum } from './components/Impressum';
export function App() {
  const [currentHash, setCurrentHash] = useState(window.location.hash);
  useEffect(() => {
    const handleHashChange = () => {
      setCurrentHash(window.location.hash);
      window.scrollTo(0, 0);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  return <div className="min-h-screen bg-white font-light text-black selection:bg-black selection:text-white grid-background" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        {currentHash === '#impressum' ? <Impressum data-id="element-3" /> : <>
            <Hero data-id="element-4" />
            <TrustBar data-id="element-5" />
            <Services data-id="element-6" />
            <Gallery data-id="element-7" />
            <Process data-id="element-8" />
            <Pricing data-id="element-9" />
            <FAQ data-id="element-10" />
            <Contact data-id="element-11" />
            <About data-id="element-12" />
          </>}
      </main>
      <Footer data-id="element-13" />
    </div>;
}